<template>
  <div class="d-inline-block" v-if="splitValues && splitValues.length > 1">
    <router-link :to="{name: 'receipt.view', params: {id: receiptUuid}}" v-if="$hasPermission('view_receipt')">
      {{ splitValues[0] }}
    </router-link>
    <span v-else>
      {{ splitValues[0] }}
    </span>
    /
    <router-link :to="{name: 'inventory.view', params: {id: inventoryUuid}}" v-if="$hasPermission('view_inventoryitem')">
      {{ splitValues[1] }}
    </router-link>
    <span v-else>
      {{ splitValues[1] }}
    </span>
  </div>
</template>

<script>
  export default {
    name: "LinkedStockNo",
    props: {
      receiptUuid: {
        type: String,
        required: true
      },
      inventoryUuid: {
        type: String,
        required: true
      },
      stockNo: {
        type: String,
        required: true
      },
    },
    computed: {
      splitValues() {
        return this.stockNo.split('/')
      }
    },
  }
</script>

<style scoped>

</style>
